/**
 * @file Unit create page: unit details plus default-charge-template drafts;
 * the templates table shows a direct-payment label (shown only for
 * DIRECT_UNTRACKED, read-only — this page carries no route control).
 *
 * Flow: `/app/unit/create` → UnitCreateWillMount → dispatches
 * GLOBAL_UNIT_CREATE_START on save → reads `properties.byId`.
 * Exceptions: saga `onError` resets the saving flag; generic snackbar path.
 */
import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { PAYMENT_ROUTE } from "../../../Entity/Entities/Charge/PaymentRoute";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import UnitCreateWillMount from "../../../Middleware/Middlewares/UnitCreateWillMount";
import { Attachment } from "../../Partials/Attachment/Attachment";
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import Formatter from "../../../Localization/Formatter";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import AgencyFeeContainer from "../../../Entity/Entities/AgencyFee/AgencyFeeContainer";
import { AgencyFeeCreate } from "../../Partials/Dialog/AgencyFeeCreate";
// import { AgencyFeeUpdate } from "../../Partials/Dialog/AgencyFeeUpdate";
import AgencyFeeFactory from "../../../Entity/Factories/AgencyFeeFactory";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import Translator from "../../../Translation/Translator";
import { ChargeTemplateCreate } from "../../Partials/Dialog/ChargeTemplateCreate";
import { ChargeTemplateUpdate } from "../../Partials/Dialog/ChargeTemplateUpdate";
import CurrencyContainer from "../../../Currency/CurrencyContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { ChargeTemplateInterface } from "../../../Entity/Entities/Charge/ChargeTemplateInterface";
import { TableComponent } from "../../Partials/Table/TableComponent";
import PropertyLookup from "../../Partials/Lookup/PropertyLookup";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { EntityAvatar } from "../../Partials/Avatar/EntityAvatar";
import * as uuidV4 from "uuid/v4";
import UnitTypeContainer from "../../../Entity/Entities/Unit/Type/UnitTypeContainer";
import Time from "../../../Time/Time";
import AgreementCard from "../../Partials/Agreement/AgreementCard";
import { CoachAgencyFee } from "../../Partials/Dialog/CoachAgencyFee";

import { CoachNewPropertyDialog } from "../../Partials/Dialog/CoachNewPropertyDialog";
import { CoachDialog } from "../../Partials/Dialog/CoachDialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";

class UnitCreate extends Component {
  private selectedProperty: PropertyInterface;
  private autoSelectPropertyId: number;
  private disablePropertyId: number;
  protected selectedAgencyFee: AgencyFeeInterface;

  public state = {
    id: null,
    unitNumber: "",
    unitType: UnitTypeContainer.pickIdFromLabel("apartment"),
    squareMeters: "",
    roomNumber: "",
    bedroomNumber: "",
    bathroomNumber: "",
    publicationTitle: "",
    amazonFolderName: uuidV4(),
    openLeavePrompt: false,
    beta: false,
    hasModifiedData: false,
    nextPath: "",
    isSaving: false,
    attachments: [],
    newChargeTemplatePopupOpen: null,
    isChargeTemplatePopupOpen: false,
    isUpdating: false,

    // charge templates
    chargeTemplates: [],
    anchorElChargeTemplate: null,
    selectedChargeTemplate: null,
    selectedChargeIndex: null,
    defaultAgencyFees: [],
    isAgencyFeeDialogOpen: false,
    anchorElAgencyFees: null,
    isAgencyRemoveDialog: false,
    agencyFee: null,
    showAgencyFeeErrorDialog: false,

    // signing popups
    isSigningProcess: false,
    isRentContractSigningPrePopupOpen: false,
    rentPriceCreatePopupWasShown: false,
    agencyFeeCreatePopupWasShown: false,
    isAgencyFeeContractSigningPrePopupOpen: false,
    isRentPriceCreatePopupOpen: false,
    isAgencyFeeСreatePopupOpen: false,
    setManualAgencyFee: false,

    //coach popups
    openCoachCreateNewProperty: false,
    propertyCreateByCoach: false,
    openPropertyOwnerCoachDialog: false,
    ownerCreateByCoach: false,
    openPrePropertyOwnerCoachDialog: false,
    ownerType: "company",
    ownerTypeСhose: true,
    defaultCompanyName: "",
    defaultAddressName: null
  };

  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_UNIT_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    UnitCreateWillMount,
    PreventPageLeave
  ];

  constructor(public props) {
    super(props);

    this.save = this.save.bind(this);
    this.done = this.done.bind(this);
    this.handleCreatedProperty = this.handleCreatedProperty.bind(this);
    this.selectProperty = this.selectProperty.bind(this);
    this.clearProperty = this.clearProperty.bind(this);
    this.getPropertyLogo = this.getPropertyLogo.bind(this);
  }

  public componentDidMount() {
    // We have to have a short delay otherwise focus does not work in Safari and Chrome.
    setTimeout(() => {
      // If we can auto-select an entity, we should also make next button clickable.
      if (this.autoSelectPropertyId &&  this.autoSelectPropertyId > 0) {
        return;
      }

      // Otherwise, we have to focus the PropertyLookup component because of user experience...
      (this.refs.PropertyLookup as any) && (this.refs.PropertyLookup as any).refs.instance.ref.focus();
    }, 10);
  }

  public save() {
    let unit = {
      propertyId: this.selectedProperty && this.selectedProperty.id,
      unitNumber: this.state.unitNumber,
      unitTypeId: this.state.unitType,
      squareMeters: this.convertToInteger(this.state.squareMeters),
      roomNumber: this.convertToInteger(this.state.roomNumber),
      bedroomNumber: this.convertToInteger(this.state.bedroomNumber),
      bathroomNumber: this.convertToInteger(this.state.bathroomNumber),
      publicationTitle: this.state.publicationTitle,
      amazonFolderName: this.state.amazonFolderName,

    }

    if(this.state.chargeTemplates.length > 0) {
      unit["chargeTemplates"] = this.state.chargeTemplates
    }
    if(this.state.defaultAgencyFees.length > 0){
      unit["agencyFeeTemplates"] = this.state.agencyFee;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_UNIT_CREATE_START,
        payload: {
          unit: unit
        },
        onSuccess: unit => {
          if (this.state.nextPath) {
            return this.redirect(this.state.nextPath);
          }

          const savedDataBeforeRedirecting = {...this.props.app.savedDataBeforeRedirecting};

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
          });

          savedDataBeforeRedirecting.createdUnit = unit;

          this.props.dispatch({
            type: Constants.SAVED_DATA_BEFORE_REDIRECTING,
            payload: {
              savedDataBeforeRedirecting: {...savedDataBeforeRedirecting}
            }
          });

          return this.setState({
            isSigningProcess: false,
            rentPriceCreatePopupWasShown: false,
            agencyFeeCreatePopupWasShown: false,
            nextPath: !!this.browser.history.getPreviousPage() &&
                      (this.browser.history.getPreviousPage().includes("contract/create") ||
                      this.browser.history.getPreviousPage().includes("contract/update") ||
                      this.browser.history.getPreviousPage().includes("contract/renew")) ?
                         this.browser.history.getPreviousPage() : `/app/unit/update/${unit.id}`,
          }, this.redirectBack);
        },
        onError: err => {
          const showChargeTemplateErrorDialog = err.fields.some(field => field.indexOf("chargeTemplates") === 0);
          const showAgencyFeeErrorDialog = err.fields.some(field => field.indexOf("agencyFeeTemplates") === 0);

          this.setState({
            isSaving: false,
            hasModifiedData: true,
            isSigningProcess: false,
            rentPriceCreatePopupWasShown: false,
            agencyFeeCreatePopupWasShown: false
          })

          if(showChargeTemplateErrorDialog) {
            let chargeTemplatesErrorRows = [];
            let chargeTemplatesErrorIndexRows = err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            .map(field =>  parseInt(field.match(/\d+/)));
            let chargeTemplatesError =  err.fields.filter(field => field.indexOf("chargeTemplates") === 0)
            let chargeTemplatesErrorField;
            if(chargeTemplatesError[0]){
              chargeTemplatesErrorField = chargeTemplatesError[0].split(".")
            }
            chargeTemplatesErrorRows.push(chargeTemplatesErrorIndexRows[0]); // just set first error from array
            const chargeTemplates = this.state.chargeTemplates.map( (chargeTemplate, index) => {
              return {
                ...chargeTemplate,
                error: chargeTemplatesErrorRows.some(field => field === index)
              }
            })

            this.setState({
              chargeTemplates: chargeTemplates,
              showAgencyFeeErrorDialog: false
            })

            if(showChargeTemplateErrorDialog) {
              return this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("error-notvaliddatata-chargetemplate",
                                   {
                                              field: this.trans(`label-${chargeTemplatesErrorField[1]}`)
                                           }),
                  type: "error"
                }
              });
            }
            return;
          }


          if(showAgencyFeeErrorDialog) {
            let agencyFeeError =  err.fields.filter(field => field.indexOf("agencyFeeTemplates") === 0)
            let agencyFeeErrorField;
            if(agencyFeeError[0]){
              agencyFeeErrorField = agencyFeeError[0].split(".")
            }
            const chargeTemplates = this.state.chargeTemplates.map(chargeTemplate => {
              return {
                ...chargeTemplate,
                error: false
              }
            })

            this.setState({
              chargeTemplates: chargeTemplates,
              showAgencyFeeErrorDialog: showAgencyFeeErrorDialog,
            })

            if(showAgencyFeeErrorDialog) {
              return this.props.dispatch({
                type: Constants.SNACKBAR_ADD_MESSAGE,
                payload: {
                  message: this.trans("error-notvaliddatata-agencyfeeunit",
                                   {
                                            field: this.trans(`label-${agencyFeeErrorField[1]}`)
                                           }),
                  type: "error"
                }
              });
            }
            return;
          }
        }
      });
    });
  }

  public componentWillUnmount() {
    if (this.state.nextPath) {
      this.redirect(this.state.nextPath);
    }
  }

  public done(): void {
    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });

    this.redirectBack();
  }

  public handleCreatedProperty(property: PropertyInterface): void {
    this.selectedProperty = property;
    this.autoSelectPropertyId = property.id;

    this.setState({
      autoSelectPropertyId: property.id
    });
  }

  public selectProperty(property: PropertyInterface, isManuallySelected: boolean): void {
    this.selectedProperty = property;
    this.autoSelectPropertyId = property.id;
    let inheritAgencyFee;

    if(property.defaultAgencyFees[0]){
      inheritAgencyFee = {...property.defaultAgencyFees[0].data}
      inheritAgencyFee["objectType"] = AgencyFeeContainer.pickIdFromLabel("Unit");
      inheritAgencyFee["currency"] = 1;
      inheritAgencyFee["fixedPlusPercentageMode"] = property.defaultAgencyFees[0].fixedPlusPercentageMode.id;
      inheritAgencyFee["firstDate"] = Time.formatOrNull(property.defaultAgencyFees[0]?.firstDate);
      inheritAgencyFee["lastDate"] = Time.formatOrNull(property.defaultAgencyFees[0]?.lastDate);
      delete inheritAgencyFee.objectId;
      delete inheritAgencyFee.id;
    }

    this.setState({
      hasModifiedData: isManuallySelected,
      autoSelectPropertyId: property.id,
      defaultAgencyFees:  this.state.setManualAgencyFee ? this.state.defaultAgencyFees : property.defaultAgencyFees[0] ? [property.defaultAgencyFees[0]] : [],
      agencyFee: this.state.setManualAgencyFee ? this.state.agencyFee : inheritAgencyFee
    });
  }

  public clearProperty(): void {
    (this.refs.PropertyLookup as any) && (this.refs.PropertyLookup as any).refs.instance.clear();
    this.selectedProperty = undefined;
    this.autoSelectPropertyId = undefined;

    this.setState({
      autoSelectPropertyId: null,
      hasModifiedData: true
    });
  }

  public getPropertyLogo(): string {
    if (typeof this.selectedProperty !== "undefined") {
      return this.selectedProperty.avatar;
    }

    return this.image.get("property");
  }

  public openChargeTemplateCreatePopup = () => {
    this.setState({
      newChargeTemplatePopupOpen: true
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true
      })
    });
  }

  public updateChargeTemplate = (updatedChargeTemplate: ChargeTemplateInterface): any => {
    let updatedChargeTemplates = this.state.chargeTemplates;
    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1, updatedChargeTemplate)
    updatedChargeTemplates.sort(this.chargeTemplateComparer)


    this.setState({
      chargeTemplates: updatedChargeTemplates,
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      isUpdating: false,
      selectedChargeIndex: null
    })
  }

  public getChargeTemplatePopupContent = (): any => {
    if (this.state.isUpdating) {
      return (
        <ChargeTemplateUpdate
          {...this.props}
          entity={"default"}
          chargeTemplate={this.state.selectedChargeTemplate}
          onSave={this.updateChargeTemplate}
          onCancel={this.closeChargeTemplatePopup}
          chargeTemplateCreatedOnFrontend={true}
          isDefault={this.state.selectedChargeTemplate?.isDefault}
          showInformationText={true}
        />
      );
    }

    return (
      <ChargeTemplateCreate
        {...this.props}
        entity={"default"}
        selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
        onSave={this.addChargeTemplate}
        onCancel={this.closeChargeTemplatePopup}
        chargeTemplateCreatedOnFrontend={true}
        isDefault={true}
        showInformationText={true}
      />
    );
  }

  public addChargeTemplate = (chargeTemplate, callback?): any => {
    const chargeTemplates = [...this.state.chargeTemplates, chargeTemplate];
    chargeTemplates.sort(this.chargeTemplateComparer)

    this.setState({
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      chargeTemplates: chargeTemplates
    }, () => {
      this.setState({
        isUpdating: false
      }, () => {
        if (typeof callback === "function") {
          callback();
        }
      })
    })
  }

  public closeChargeTemplatePopup = () => {
    this.setState({
      isChargeTemplatePopupOpen: false,
      isUpdating: false
    });
  }

  public chargeTemplateComparer = (a, b) => {
    return this.comparer(a.repeatPeriod, b.repeatPeriod) ||
      this.comparer(TypeContainer.pickLabelFromId(a.type),TypeContainer.pickLabelFromId(b.type));
  }

  public openChargeTemplateUpdatePopup = (chargeTemplate: ChargeTemplateInterface, index): any => {
    this.setState({
      selectedChargeIndex: index,
      selectedChargeTemplate: chargeTemplate,
      isUpdating: true,
      anchorElChargeTemplate: null,
      newChargeTemplatePopupOpen: false
    }, () => {
      this.setState({
        isChargeTemplatePopupOpen: true,
        isUpdating: true
      })
    });
  }

  protected openChargeTemplateMenu = (event: any, chargeTemplate: ChargeTemplateInterface, index): void => {
    this.setState({
      selectedChargeTemplate: chargeTemplate,
      anchorElChargeTemplate: event.currentTarget,
      selectedChargeIndex: index
    });
  }

  protected closeChargeTemplateMenu = (): void => {
    this.setState({
      anchorElChargeTemplate: null
    });
  }

  public comparer = (a, b) => {
    if (a > b) {
      return 1;
    }
    if (a < b) {
      return -1;
    }

    return 0;
  }

  public deleteChargeTemplate = (): any => {
    this.closeChargeTemplateMenu();

    const updatedChargeTemplates = this.state.chargeTemplates;
    updatedChargeTemplates.splice(this.state.selectedChargeIndex, 1)
    updatedChargeTemplates.sort(this.chargeTemplateComparer)


    this.setState({
      chargeTemplates: updatedChargeTemplates,
      hasModifiedData: true,
      isChargeTemplatePopupOpen: false,
      selectedChargeIndex: null
    })
  }

  public openAgencyFeeDialog = () => {
    return this.setState({
      isAgencyFeeDialogOpen: true
    });
  }

  public closeAgencyFeeDialog = () => {
    // sending empty error array to clear page errors
    this.props.dispatch({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: []
      }
    });

    this.closeMenuAgencyFees();
    this.cancelSigningProcess();
    this.setState({
      isAgencyFeeDialogOpen: false,
      isAgencyFeeСreatePopupOpen: false,
      isUpdating: false
    });
  }

  protected closeMenuAgencyFees = (): void => {
    this.setState({
      anchorElAgencyFees: null
    });
  }

  public getChargeTemplates = () => {
    return [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) => !!chargeTemplate && !chargeTemplate.contractId)
      .map((chargeTemplate, index) => {
        return (
          <TableRow
            hover
            key={`chargeTemplate-${chargeTemplate.id}`}
            className={`clickable-entity`}
            onClick={() => {
                this.openChargeTemplateUpdatePopup(chargeTemplate, index);
            }}
          >
            <TableCell>
              { chargeTemplate.error &&
                <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "6px"}}>
                  <div
                    className="icon icon-ic-info red"
                  >
                  </div>
                </div>
              }
            </TableCell>
            <TableCell style={{width: "15%"}}>
              {this.formatter.formatNumber(chargeTemplate.amount * 100, CurrencyContainer.pickFromId(chargeTemplate.currency))}
            </TableCell>
            <TableCell style={{width:"15%"}}>{Formatter.checkTranslationType(this.trans(PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod)), PeriodContainer.pickLabelFromId(chargeTemplate.repeatPeriod))}</TableCell>
            <TableCell style={{width:"20%"}}>{Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(chargeTemplate.type), {}, "", false), TypeContainer.pickLabelFromId(chargeTemplate.type), chargeTemplate?.type?.system)}</TableCell>
            <TableCell style={{width:"10%"}}>{chargeTemplate?.paymentRouteId === PAYMENT_ROUTE.DIRECT_UNTRACKED ? this.trans("label-direct") : ""}</TableCell>
            <TableCell style={{width:"20%"}}>{chargeTemplate.description}</TableCell>
            <TableCell style={{width:"15%"}}>{this.formatter.formatDate(chargeTemplate.dueDateFirstPayment) || this.formatter.formatDate(chargeTemplate.firstDate)}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openChargeTemplateMenu(e, chargeTemplate, index)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorElChargeTemplate}
                  open={Boolean(this.state.anchorElChargeTemplate) && this.state.selectedChargeTemplate && this.state.selectedChargeTemplate.id === chargeTemplate.id}
                  onClose={this.closeChargeTemplateMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.openChargeTemplateUpdatePopup(this.state.selectedChargeTemplate, this.state.selectedChargeIndex)}
                    >
                    <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={() => this.deleteChargeTemplate()}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public getAgencyFeeDialogTitle = (): string => {
    return this.trans("dialog/agreement-title");
  }

  // public getAgencyFeeDialogContent = (): any => {
  //   if (this.state.isUpdating) {
  //     return (
  //       <AgencyFeeUpdate
  //         {...this.props}
  //         agencyFee={this.selectedAgencyFee}
  //         showDates={true}
  //         onSave={this.saveAgencyFee}
  //         onCancel={this.closeAgencyFeeDialog}
  //       />
  //     );
  //   }

  //   return (
  //     <AgencyFeeCreate
  //       {...this.props}
  //       objectType={AgencyFeeContainer.pickIdFromLabel("Unit")}
  //       objectId={null}
  //       showDates={true}
  //       onSave={this.addAgencyFee}
  //       onCancel={this.closeAgencyFeeDialog}
  //     />
  //   );
  // }

  public saveAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          },
          type: "error"
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if(!agencyFee.fixedFee && !agencyFee.percentageFee && (agencyFee.fixedFee !== 0 && agencyFee.percentageFee !== 0)) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(String(agencyFee.fixedFee))).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(String(agencyFee.percentageFee)).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee ) ? null : percentageFee ;
    delete agencyFee.objectId;
    agencyFee["objectType"] = AgencyFeeContainer.pickIdFromLabel("Unit");
    delete agencyFee.id;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);
    this.selectedAgencyFee = createdAgencyFee;

    this.setState({
      defaultAgencyFees: [createdAgencyFee],
      agencyFee: agencyFee,
      setManualAgencyFee: true
    });
  }

  public addAgencyFee = (agencyFee): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if(!agencyFee.fixedFee && !agencyFee.percentageFee && (agencyFee.fixedFee !== 0 && agencyFee.percentageFee !== 0)) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(agencyFee.fixedFee)).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(agencyFee.percentageFee).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee ;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee ;
    delete agencyFee.objectId;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);
    this.selectedAgencyFee = createdAgencyFee;

    this.setState({
      defaultAgencyFees: [createdAgencyFee],
      agencyFee: agencyFee,
      setManualAgencyFee: true,
    });
  }

  public updateAgencyFee = (agencyFee: AgencyFeeInterface): any => {
    this.selectedAgencyFee = agencyFee;

    this.setState({
      isUpdating: true,
      anchorElAgencyFees: null
    }, () => {
      this.openAgencyFeeDialog();
    });
  }

  protected openMenuAgencyFees = (event: any, agencyFee: AgencyFeeInterface): void => {
    this.selectedAgencyFee = agencyFee;

    this.setState({
      anchorElAgencyFees: event.currentTarget
    });
  }

  public closePrompt = () => {
    this.setState({
      isAgencyRemoveDialog: false,
    })
  }

  public deleteAgencyFee = () => {
    this.setState({
      defaultAgencyFees: [],
      isAgencyRemoveDialog: false,
      agencyFee: null,
      showAgencyFeeErrorDialog: false
    });
  }

  public getDefaultAgencyFees = () => {
    return this.state.defaultAgencyFees && this.state.defaultAgencyFees.map((agencyFee: AgencyFeeInterface) => {
      return (
        <TableRow
          hover
          key={agencyFee.id}
          className={`clickable-entity`}
          onClick={() => {
            this.updateAgencyFee(agencyFee);
          }}
        >
          <TableCell>
          { this.state.showAgencyFeeErrorDialog &&
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "6px"}}>
              <div
                className="icon icon-ic-info red"
              >
              </div>
            </div>
          }
          </TableCell>
          <TableCell style={{width: "auto"}}>
            {!agencyFee.fixedFee &&  agencyFee.fixedFee !== 0 ? "" : this.formatter.formatNumber(agencyFee.fixedFee, agencyFee.currency)}
          </TableCell>
          <TableCell>{!agencyFee.percentageFee && agencyFee.percentageFee !== 0 ? "" : `${this.formatter.simpleFormatNumber(agencyFee.percentageFee, false)}%`}</TableCell>
          <TableCell style={{width: "180px"}}>{this.trans(`assignment_service_status_type_${ AssignmentServiceStatusTypeContainer.pickLabelFromId(agencyFee?.assignmentServiceStatus)?.toLowerCase()}`)}</TableCell>
          <TableCell>{this.formatter.formatDate(agencyFee.firstDate)}</TableCell>
          <TableCell>{this.formatter.formatDate(agencyFee.lastDate)}</TableCell>
          <TableCell
            style={{width: "5%"}}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <div>
              <IconButton
                onClick={e => this.openMenuAgencyFees(e, agencyFee)}
              >
                <div className="icon icon-ic-more-vert"></div>
              </IconButton>
              <Menu
                id="simple-menu"
                anchorEl={this.state.anchorElAgencyFees}
                open={Boolean(this.state.anchorElAgencyFees) && this.selectedAgencyFee && this.selectedAgencyFee.id === agencyFee.id}
                onClose={this.closeMenuAgencyFees}
                disableAutoFocusItem={true}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left"
                }}
                getContentAnchorEl={null}
              >
                <MenuItem
                  onClick={() => this.updateAgencyFee(this.selectedAgencyFee)}
                >
                  <ListItemIcon><div className="icon icon-ic-edit icon-color"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                </MenuItem>
                <MenuItem
                  className="delete-action"
                  onClick={() => this.setState({ agencyFee: this.selectedAgencyFee, isAgencyRemoveDialog: true, anchorElAgencyFees: null})}
                >
                  <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                  <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                </MenuItem>
              </Menu>
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  public cancelSigningProcess = () => {
    return this.setState({
      isContractSigningPopupOpen: false,
      contractSigningPopupWasShown: false,
      isRentPriceCreatePopupOpen: false,
      rentPriceCreatePopupWasShown: false,
      isDepositPriceCreatePopupOpen: false,
      depositPriceCreatePopupWasShown: false,
      agencyFeeCreatePopupWasShown: false,
      isPayUntilDatePopupOpen: false,
      payUntilDatePopupWasShown: false,
      shouldApplyPayChargesUntilDate: false,
      isAgencyFeeСreatePopupOpen: false,
      isSigningProcess: false,
      isRentContractSigningPrePopupOpen: false,
      isDepositContractSigningPrePopupOpen: false,
      isAgencyFeeContractSigningPrePopupOpen: false
    });
  }

  public addAgencyFeeFromSignProcessDialog = (agencyFee): any => {
    if (agencyFee.chargeTypeIds.length === 0) {
      return this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: {
            fields: ["chargeTypeIds"],
            translatedMessage: this.trans("be_ajv_not_validated")
          }
        }
      });
    } else {
      this.props.dispatch({
        type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
        payload: {
          err: []
        }
      });
    }

    if(!agencyFee.fixedFee && !agencyFee.percentageFee && (agencyFee.fixedFee !== 0 && agencyFee.percentageFee !== 0)) {
      return this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("should_be_filled_one_of_the_fees_types"),
          type: "error"
        }
      });
    }

    const fixedFee = parseFloat((100 * parseFloat(String(Formatter.deleteExtraSpace(agencyFee.fixedFee)).replace(",", "."))).toFixed(2));
    const percentageFee = parseFloat(Formatter.deleteExtraSpace(agencyFee.percentageFee).replace(",", "."));
    agencyFee.fixedFee = isNaN(fixedFee) ? null : fixedFee;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee ;
    agencyFee.percentageFee = isNaN(agencyFee.percentageFee) ? null : percentageFee ;
    delete agencyFee.objectId;
    const createdAgencyFee: AgencyFeeInterface = AgencyFeeFactory.create(agencyFee);

    this.setState({
      defaultAgencyFees: [createdAgencyFee],
      agencyFee: agencyFee,
      isAgencyFeeDialogOpen: false,
      isAgencyFeeСreatePopupOpen: false,
      isUpdating: false,
      setManualAgencyFee: true
    }, this.save);
  }

  public onClosePropertyCoach = (property) => {
    this.selectedProperty = property;
    this.setState({
      openCoachCreateNewProperty: false,
      openCoachCreateNewUnit: true,
      ownerCreateByCoach: null,
      defaultAddressName: null
    })
  }

  public onCloseCoach  = (owner) => {
    this.setState({
      openCoachCreateNewProperty: true,
      openPropertyOwnerCoachDialog: false,
      ownerCreateByCoach: owner,
      defaultCompanyName: ""
    })
  }

  public openFirstStep = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: true,
      // ownerType: "",
      // ownerTypeСhose: false
    })
  }

  public openPropertyCoachDialog = () => {
    this.setState({
      openCoachCreateNewUnit: false,
      openCoachCreateNewProperty: true
    })
  }

  public selectEntityName = (name, type) => {
    this.setState({
      defaultAddressName: type === "property" ? name : null,
    })
  }

  public openPropertyOwnerCoachDialog  = (defaultCompanyName) => {
    this.setState({
      openPrePropertyOwnerCoachDialog: true,
      openCoachCreateNewProperty: false,
      defaultCompanyName: defaultCompanyName,
      defaultAddressName: null
    })
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      ownerTypeСhose: true
    });
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/propertyowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.ownerType}
            onChange={this.chooseOwnerType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div className="hint-styles">
          {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
        </div>
      </div>
    )
  }

  public render() {
    const monthlyChargeTemplatesAmount = [...this.state.chargeTemplates]
      .filter((chargeTemplate: ChargeTemplateInterface) =>
        !chargeTemplate?.contractId &&
        chargeTemplate?.repeatPeriod === PeriodContainer.pickIdFromLabel("monthly") &&
        chargeTemplate?.amount
      )
      .map((chargeTemplate: ChargeTemplateInterface) => chargeTemplate.amount)
      .reduce((a, b) => a + b, 0);

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("create-unit")}</h1>
              <div className="button-container">
                <Button
                  color="primary"
                  onClick={this.done}
                  style={{marginRight: "20px"}}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={this.state.isSaving === true}
                  onClick={()=> this.setState({isSigningProcess: true}, this.save)}
                >
                  {this.state.isSaving === true ? this.trans("button-please-wait") : this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-unit-update">
            <div className="component-wrapper no-margin-top">
              <div className="component">
                <Card className="card">
                  <div className="row align-center-icon">
                    <div className="grid align-icon-grid">
                      {
                        this.selectedProperty ?
                          this.selectedProperty.renderAvatar() :
                          this.image.getAvatarAbsolutely("", "property", null)
                      }
                    </div>
                    <div className="grid">
                        <PropertyLookup
                          {...this.props}
                          id="propertyId"
                          name="propertyId"
                          ref="PropertyLookup"
                          className="scroll-to-propertyId"
                          isInlineBlock={true}
                          width="100%"
                          containerWidth="100%"
                          floatingLabelText={this.trans("dropdown-searchforproperty-label")}
                          autoSelectId={this.selectedProperty && this.selectedProperty.id}
                          onCreate={this.handleCreatedProperty}
                          onSelect={this.selectProperty}
                          onClear={this.clearProperty}
                          saveDetailsBeforeRedirect={this.saveDetailsBeforeRedirect.bind(this, "unitCreate")}
                          disabled={this.disablePropertyId > 0}
                          error={!!this.getErrorFor("propertyId") && this.getErrorFor("propertyId")}
                          shouldOpenCoachModal={true}
                          selectEntityName={this.selectEntityName}
                          templateFor={"property"}
                          openPoaCoachDialog={() => this.setState({openCoachCreateNewProperty: true})}
                          hideNotFoundMessage={true}
                        />
                    </div>
                  </div>

                  <div className="row">
                    <div className="grid"></div>
                      <div className="grid">
                        <form>
                        <Select
                          className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
                          error={this.getErrorFor("unitTypeId")}
                          value={this.state.unitType}
                          onChange={this.sync.bind(this, this.syncronizers.UNIT_TYPE)}
                          htmlFor="unitType"
                          label={this.trans("unit-type")}
                          name="unitType" 
                          id="unitType"
                        >
                          {this.getUnitTypeSelectboxes()}
                        </Select>

                        {
                          this.selectedProperty?.units?.filter(unit => !unit.removed)?.length > 0 && (
                            <div className="row align-center-icon">
                              <div className="grid align-icon-grid" style={{marginLeft: "-62px"}}>
                                <EntityAvatar
                                  {...this.props}
                                  ref="EntityAvatar"
                                  entityName="unit"
                                />
                              </div>

                              <TextField
                                autoComplete="off"
                                // id="unitNumber"
                                // name="unitNumber"
                                className="form-element full-size scroll-to-unitNumber"
                                type="text"
                                label={this.trans("unit-number")}
                                value={this.state.unitNumber}
                                onChange={this.sync.bind(this, this.syncronizers.EVENT, "unitNumber")}
                                variant="standard"
                                error={!!this.getErrorFor("unitNumber")}
                              />
                            </div>
                          )
                        }

                        {
                          this.selectedProperty?.units?.filter(unit => !unit.removed)?.length > 0 &&
                          !!this.getErrorFor("unitNumber") && <div className="component-error-text">{this.getErrorFor("unitNumber")}</div>
                        }

                        {
                          this.selectedProperty?.units?.filter(unit => !unit.removed)?.length > 0 && (
                            <div className="hint-styles-wrapper">
                              <span className="hint-styles">{this.trans("page/unitcreate-unitnumber-info")}</span>
                            </div>
                          )
                        }

                        <TextField
                          autoComplete="off"
                          className="form-element full-size scroll-to-squareMeters"
                          label={this.trans("square-meters") + this.trans("field/optional")}
                          value={this.state.squareMeters}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "squareMeters")}
                          variant="standard"
                          error={!!this.getErrorFor("squareMeters")}
                        />
                        {!!this.getErrorFor("squareMeters") && <div className="component-error-text">{this.getErrorFor("squareMeters")}</div>}

                        <TextField
                          autoComplete="off"
                          id="rooms"
                          name="rooms"
                          className="form-element full-size scroll-to-roomNumber"
                          type="text"
                          label={this.trans("rooms") + this.trans("field/optional")}
                          value={this.state.roomNumber || ""}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "roomNumber")}
                          variant="standard"
                          error={!!this.getErrorFor("roomNumber")}
                        />
                        {!!this.getErrorFor("roomNumber") && <div className="component-error-text">{this.getErrorFor("roomNumber")}</div>}

                        <TextField
                          autoComplete="off"
                          id="bedroomNumber"
                          name="bedroomNumber"
                          className="form-element full-size scroll-to-bedroomNumber"
                          type="text"
                          label={this.trans("separate-bedrooms") + this.trans("field/optional")}
                          value={this.state.bedroomNumber}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "bedroomNumber")}
                          variant="standard"
                          error={!!this.getErrorFor("bedroomNumber")}
                        />
                        {!!this.getErrorFor("bedroomNumber") && <div className="component-error-text">{this.getErrorFor("bedroomNumber")}</div>}

                        <TextField
                          autoComplete="off"
                          // id="bathroomNumber"
                          // name="bathroomNumber"
                          className="form-element full-size scroll-to-bathroomNumber"
                          type="text"
                          label={this.trans("bathrooms") + this.trans("field/optional")}
                          value={this.state.bathroomNumber}
                          onChange={this.sync.bind(this, this.syncronizers.EVENT, "bathroomNumber")}
                          variant="standard"
                          error={!!this.getErrorFor("bathroomNumber")}
                        />
                        {!!this.getErrorFor("bathroomNumber") && <div className="component-error-text">{this.getErrorFor("bathroomNumber")}</div>}

                        {/* {this.state.beta && (
                          <TextField
                            autoComplete="off"
                            id="publicationTitle"
                            name="publicationTitle"
                            className="form-element full-size scroll-to-publicationTitle"
                            type="text"
                            label={this.trans("publication-title") + this.trans("field/optional")}
                            value={this.state.publicationTitle}
                            onChange={this.sync.bind(this, this.syncronizers.EVENT, "publicationTitle")}
                            variant="standard"
                            error={!!this.getErrorFor("publicationTitle")}
                          />
                          {!!this.getErrorFor("publicationTitle") && <div className="component-error-text">{this.getErrorFor("publicationTitle")}</div>}
                        )} */}
                      </form>
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper">
              <Card className="card no-padding">
                <div className="label-container">
                  <h3 className="card-title">
                    {this.trans("section/defaultunitchargetemplates-title")}
                  </h3>

                  <Button
                    color="primary"
                    onClick={this.openChargeTemplateCreatePopup}
                  >
                    {this.trans("button-add-price")}
                  </Button>
                  <PromptDialog
                    {...this.props}
                    title={this.state.newChargeTemplatePopupOpen ? this.trans("dialog/newdefaultchargetemplates-title") : this.trans("dialog/defaultchargetemplatesdetails-title")}
                    content={this.getChargeTemplatePopupContent()}
                    openLeavePrompt={this.state.isChargeTemplatePopupOpen}
                    onClose={this.closeChargeTemplatePopup}
                    onlyPositiveButton={false}
                    prioritizeClosing={true}
                    withoutDefaultDilaogButtons={true}
                  />
                </div>
                <div>
                  <div
                    style={{
                      padding: "10px 12px 10px 66px",
                      borderBottom: "1px solid rgba(224, 224, 224, 1)"
                    }}
                  >
                    {
                      !!monthlyChargeTemplatesAmount ?
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", {amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount * 100, this.state.chargeTemplates[0] && CurrencyContainer.pickFromId(this.state.chargeTemplates[0].currency))}</span>}) :
                        Translator.transJSX("pages/contract-section/price-info/totalmonthlyamount", {amount: <span style={{fontWeight: "bold"}}>{this.formatter.formatNumber(monthlyChargeTemplatesAmount, this.props.app.settings.user.currency)}</span>})
                    }
                  </div>
                  <TableComponent
                    {...this.props}
                    entities={this.state.chargeTemplates}
                    className="listing-table first-column-auto-width"
                    subtitle={this.trans("pages/contract-section/price-info/pricenotfound")}
                    rows={this.getChargeTemplates()}
                  />
                </div>
              </Card>
            </div>

            <div className="component-wrapper">
              <Card className="card no-padding">
                <div className="label-container">
                  <h3 className="card-title">
                    {this.trans("section/agencyfee-title")}
                  </h3>
                  {
                    this.state.defaultAgencyFees && this.state.defaultAgencyFees.length  < 1 &&
                    <Button
                    color="primary"
                    onClick={this.openAgencyFeeDialog}
                  >
                    {this.trans("section/agencyfee-button/agreement")}
                  </Button>

                  }
                </div>
                <div>       
                  <div>
                    {
                      this.state.defaultAgencyFees && this.state.defaultAgencyFees.length > 0 && this.state.defaultAgencyFees
                        .map((agencyFee: AgencyFeeInterface) => {
                          return (
                            <div className="component-wrapper no-margins has-margin-bottom">
                              <div className="component">
                                <AgreementCard 
                                  {...this.props}
                                  key={`agreement-${agencyFee?.id}`}  
                                  agencyFee={agencyFee}
                                  updateAgencyFee={agencyFee => this.updateAgencyFee(agencyFee)}
                                  removeAgencyFee={agencyFee => this.setState({ agencyFee: agencyFee, isAgencyRemoveDialog: true})}
                                  openedByDefault={true}
                                  isDefault={true}
                                />
                              </div>
                            </div>
                          );
                        })
                    }
                  </div>  
                </div>
              </Card>
            </div>

            <div className="component-wrapper">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                possibilityToSetAvatar={true}
                title={this.trans("attachments-for-unit")}
                relation="unitId"
                onAmazonFolderNameGeneration={!this.state.amazonFolderName ?
                  this.sync.bind(this, this.syncronizers.VALUE, "amazonFolderName") : null}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                attachments={this.state.attachments}
                updateParentState={attachments => this.setState({attachments: attachments})}
                onChangeAvatar={avatar => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).change(avatar)}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
              />
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("you-did-not-create-charge-rent")}
          negativeButtonLabel={this.trans("dialog-button/no")}
          positiveButtonLabel={this.trans("dialog-button/yes")}
          openLeavePrompt={this.state.isRentContractSigningPrePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isRentContractSigningPrePopupOpen: false,
              isRentPriceCreatePopupOpen: false,
              rentPriceCreatePopupWasShown: true
            }, this.save)
          }}
          onSave={() => {
            this.setState({isContractSigningPopupOpen: false, isRentContractSigningPrePopupOpen: false, isRentPriceCreatePopupOpen: true});
          }}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("title-attention") + "!"}
          content={this.trans("you-did-not-create-agency-fee")}
          negativeButtonLabel={this.trans("dialog-button/no")}
          positiveButtonLabel={this.trans("dialog-button/yes")}
          openLeavePrompt={this.state.isAgencyFeeContractSigningPrePopupOpen}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              isAgencyFeeContractSigningPrePopupOpen: false,
              isAgencyFeeСreatePopupOpen: false,
              agencyFeeCreatePopupWasShown: true
            }, this.save)
          }}
          onSave={() => {
            this.setState({isContractSigningPopupOpen: false, isAgencyFeeContractSigningPrePopupOpen: false, isAgencyFeeСreatePopupOpen: true});
          }}
          hideCross={true}
        />


        {/* // Signing process popups */}
        <PromptDialog
          {...this.props}
          title={this.state.newChargeTemplatePopupOpen ? this.trans("dialog/newdefaultchargetemplates-title") : this.trans("dialog/defaultchargetemplatesdetails-title")}
          content={
            <div>
              <ChargeTemplateCreate
                {...this.props}
                entity={"unit"}
                selectedType={TypeContainer.pickIdFromLabel("Basic_rent")}
                onSave={this.addChargeTemplate}
                onSaveCallback={() => {
                  this.setState({
                    isRentPriceCreatePopupOpen: false,
                    rentPriceCreatePopupWasShown: true
                  }, this.save)
                }}
                onCancel={this.cancelSigningProcess}
                positiveButtonLabel={this.trans("button-continue")}
                negativeButtonLabel={this.trans("button-cancel")}
                firstDate={null}
                additionalButton={
                  (
                    <Button
                      key="dialog-additional-btn"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          isRentPriceCreatePopupOpen: false,
                          rentPriceCreatePopupWasShown: true
                        }, this.save)
                      }}
                    >
                      {this.trans("label-skip")}
                    </Button>
                  )
                }
              />
            </div>
          }
          openLeavePrompt={this.state.isRentPriceCreatePopupOpen}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
        />

        <PromptDialog
          {...this.props}
          title={this.getAgencyFeeDialogTitle()}
          subtitle={this.trans("dialog-add-agency-fee-subtitle")}
          content={
            <div>
              <AgencyFeeCreate
                {...this.props}
                objectType={AgencyFeeContainer.pickIdFromLabel("Unit")}
                showDates={true}
                onSave={this.addAgencyFeeFromSignProcessDialog}
                onCancel={this.closeAgencyFeeDialog}
                positiveButtonLabel={this.trans("button-continue")}
                negativeButtonLabel={this.trans("button-cancel")}
                additionalButton={
                  (
                    <Button
                      key="dialog-additional-btn"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          isAgencyFeeСreatePopupOpen: false,
                          agencyFeeCreatePopupWasShown: true
                        }, this.save)
                      }}
                    >
                      {this.trans("label-skip")}
                    </Button>
                  )
                }
              />
            </div>
          }
          openLeavePrompt={this.state.isAgencyFeeСreatePopupOpen}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
          hideCross={true}
        />

        <CoachNewPropertyDialog
          {...this.props}
          openCoachCreateNewProperty={this.state.openCoachCreateNewProperty}
          openPropertyOwnerCoachDialog={this.openPropertyOwnerCoachDialog}
          onClosePropertyCoach={this.onClosePropertyCoach}
          defaultAddressName={this.state.defaultAddressName}
          ownerCreateByCoach={this.state.ownerCreateByCoach}
        />

        <CoachDialog
          {...this.props}
          openPropertyOwnerCoachDialog={this.state.openPropertyOwnerCoachDialog}
          type={this.state.ownerType}
          defaultCompanyName={this.state.defaultCompanyName}

          onCloseCoach={this.onCloseCoach}
          openFirstStep={this.openFirstStep}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/propertyowner-title")}
          innerDialogClasses="coach-owner dialog-assistant"
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPrePropertyOwnerCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPrePropertyOwnerCoachDialog: false,
              openCoachCreateNewProperty: true
              // ownerType: "",
              // ownerTypeСhose: false
            });
          }}
          onSave={() => {this.setState({ openPrePropertyOwnerCoachDialog: false, openPropertyOwnerCoachDialog: true }); }}
          diableContinueButton={!this.state.ownerTypeСhose}
        />

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <DeleteEntityPrompt
          {...this.props}
          entityName={'agency-fee-remove-from-settings-page'}
          isOpen={this.state.isAgencyRemoveDialog}
          onCancel={this.closePrompt}
          onDelete={this.deleteAgencyFee}
        />

        {this.state.isAgencyFeeDialogOpen && (
          <CoachAgencyFee
            {...this.props}
            agencyFee={this.state.isUpdating ? this.selectedAgencyFee : null}
            objectType={this.state.isUpdating ? this.selectedAgencyFee?.objectType : AgencyFeeContainer.pickIdFromLabel("Unit")}
            objectId={this.state.isUpdating ? this.selectedAgencyFee?.objectId : this.getAgency()?.id}
            onCancel={this.closeAgencyFeeDialog}
            openCoach={this.state.isAgencyFeeDialogOpen}
            showDates={true}
            onSave={this.state.isUpdating ? this.saveAgencyFee : this.addAgencyFee}
          />
        )}

        {/* <PromptDialog
          {...this.props}
          title={this.getAgencyFeeDialogTitle()}
          subtitle={this.trans("dialog-add-agency-fee-subtitle")}
          content={this.getAgencyFeeDialogContent()}
          openLeavePrompt={this.state.isAgencyFeeDialogOpen}
          onClose={this.closeAgencyFeeDialog}
          onlyPositiveButton={false}
          prioritizeClosing={true}
          withoutDefaultDilaogButtons={true}
        /> */}

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    component: state.unitCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
    UnitCreate
);
